import {SELECT_ORGANISATION} from '../actions/constant';

const initialState = null;

/**
 * WARNING! Organisation state is for now completly store into local storage!
 * Add additionnal information with caution
 */
export default function organisation(state = initialState, action = {}) {
  if (action.type === SELECT_ORGANISATION) {
    return action.payload.organisation;
  }

  return state;
}
